// Lucide has no butterfly; drawn in lucide's style (24 grid, stroke 2, round caps, no fill).
import React from 'react';
import Svg, { Path } from 'react-native-svg';

export function Butterfly({ size = 24, color = 'currentColor' }: { size?: number; color?: string }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <Path d="M12 8v11" />
      <Path d="M12 8C12 5 9 3 5.5 3 3.5 3 3 4.5 3 6c0 3 2 5 4.5 5.5C5.5 12.5 4.5 14 5 16c.5 2.5 3 3 5 2 1.2-.6 2-1.6 2-3" />
      <Path d="M12 8c0-3 3-5 6.5-5 2 0 2.5 1.5 2.5 3 0 3-2 5-4.5 5.5 2 1 3 2.5 2.5 4.5-.5 2.5-3 3-5 2-1.2-.6-2-1.6-2-3" />
      <Path d="M12 8 10 4.5M12 8l2-3.5" />
    </Svg>
  );
}
